import { FC } from "react";
import { Button, Modal } from "../../../components";
import { ModalActions, ModalHeader } from "../../../components/Modal";
import useTranslateMessage from "../../../hooks/useTranslateMessage";

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

const HeaderConfirmLogoutModal: FC<Props> = ({ onConfirm, onCancel }) => {
  const t = useTranslateMessage();
  return (
    <Modal isOpen onClose={onCancel}>
      <ModalHeader>{t({ id: "logout-confirmation-message" })}</ModalHeader>

      <ModalActions>
        {/* Logout */}
        <Button onClick={onConfirm} data-cy="confirm-logout">
          {t({ id: "headerUserMenu-logoutButton" })}
        </Button>

        {/* Return */}
        <Button variant="contained" onClick={onCancel}>
          {t({ id: "return" })}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export { HeaderConfirmLogoutModal };
